<template>
  <div></div>
</template>
<script>
export default {
  name: "switch-select",
  props: {
    label: "",
    model: false
  },

  data() {
    return {
      select: false
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    setModelData(val) {
      this.$emit("update", this.select);
    }
  }
};
</script>
